export default __webpack_public_path__ + "static/media/avatar.8514119c.svg";